import React from 'react';
import ProgressBar from '../ProgressBar';
import NotificationBar from '../Notification/NotificationBar';
import Nav from '../Nav';

class LayoutNotLoggedIn extends React.Component {
  render() {
    const { data, location, children } = this.props;
    const { pathname } = location;
    const { notification, openPlatform } = data;

    const { isMokaOpenApiRedirect } = openPlatform.login;

    return (
      <div className="full-height">
        <ProgressBar updateTime={500} currentPath={pathname} />
        <header
          className={`mk-head-bar ${
            isMokaOpenApiRedirect ? 'mk-open-api-head-bar' : ''
          }`}
        >
          <Nav
            location={location}
            isMokaOpenApiRedirect={isMokaOpenApiRedirect}
          />
          <NotificationBar notification={notification} location={location} />
        </header>

        <div className="separator" />
        <div
          className={`full-height section-content ${this._getClassByPath()}`}
        >
          <div className="container-full-nosub box-content-container not-logged-in">
            {children}
          </div>
        </div>
      </div>
    );
  }

  _getClassByPath() {
    const { location } = this.props;
    const classbyPath = location.pathname.split('/');
    if (classbyPath[1] === 'reset-password') {
      return 'reset-password';
    }
    return classbyPath[classbyPath.length - 1];
  }
}

export default LayoutNotLoggedIn;
